<template>
  <div>
    <div class="store">
      <div class="left_list_title">
        <span>街区店铺情况</span>
      </div>
      <div class="store_main">
        <img src="@/assets/img/img_store.png" />
        <div class="store_detail">
          <span>{{ shop_state_1.label }}</span>
          <div class="store_number_wrapper">
            <div
              class="store_number store_bg1"
              v-for="(item,index) in shop_state_1.values"
              :key="index"
            >
              {{ item }}
            </div>
            <!-- <div class="store_number store_bg1">2</div>
            <div class="store_number store_bg1">3</div>
            <div class="store_number store_bg1">1</div> -->
          </div>
        </div>
        <img src="@/assets/img/img_store_display.png" class="store_display" />
        <div class="store_detail">
          <span>{{ shop_state_2.label }}</span>
          <div class="store_number_wrapper">
              <div
              class="store_number store_bg2"
              v-for="(item,index) in shop_state_2.values"
              :key="index"
            >
              {{ item }}
            </div>
            <!-- <div class="store_number store_bg2">3</div>
            <div class="store_number store_bg2">4</div> -->
          </div>
        </div>
        <img src="@/assets/img/img_store_display.png" class="store_display" />
        <div class="store_detail">
          <span>{{ shop_state_3.label }}</span>
          <div class="store_number_wrapper">
                         <div
              class="store_number store_bg3"
              v-for="(item,index) in shop_state_3.values"
              :key="index"
            >
              {{ item }}
            </div>
            <!-- <div class="store_number store_bg3">0</div>
            <div class="store_number store_bg3">0</div>
            <div class="store_number store_bg3">0</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "@/assets/js/swiper.min.js";
import * as echarts from "echarts";

export default {
  data() {
    return {
      shop_state_1: { label: "中山路及各街巷临街店铺数", values: ['1','0','3','9'] },
      shop_state_2: { label: "在经营店铺数", values:['7','9','3']  },
      shop_state_3: { label: "空铺数", values: ['2','4','6']  },
    };
  },
  props: {
    shop_state: {
      typeof: Array,
      default: () => [],
    },
  },
  components: {},
  watch: {
    shop_state: {
      deep: true,
      handler: function (newV, oldV) {
        this.getData();
      },
    },
  },
  mounted() {
  },
  created() {},
  methods: {
    getData() {
      for (let index = 0; index < this.shop_state.length; index++) {
        const element = this.shop_state[index];
        if (element.key == "total") {
          this.shop_state_1.label = element.label;
          this.shop_state_1.values = element.value.toString().split("");
        }
        if (element.key == "ing") {
          this.shop_state_2.label = element.label;
          this.shop_state_2.values = element.value.toString().split("");
        }
        if (element.key == "blank") {
          this.shop_state_3.label = element.label;
          this.shop_state_3.values = element.value.toString().split("");
        }
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>